/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2024/1/3
 */
import React, {Component} from "react";
import * as UI from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import apis from "../../../../../utils/apis";
import {BellOutlined} from "@ant-design/icons";


const {TextArea} = UI.Input
const {Option} = UI.Select

export default class EIamEndpoint extends Component {
    constructor() {
        super();
        this.state = {
            tableData: [],
            paging: {total: 0, pageNumber: 1, pageSize: 20},
            tableLoad: false,
            searchKey: {},
            editShow: false,
            editCurr: {},
            submitting: false,
            group: []
        }
    }

    componentDidMount() {
        this.executeGroupSync()
        this.tableDataSync(1)
    }

    /**
     * 加载执行分组
     */
    executeGroupSync() {
        var param = {}
        param.pageNumber = 1
        param.pageSize = 2000
        var that = this
        apis.eiamGroups(param).then(res => {
            that.setState({
                group: res.data.data.data
            })
        })
    }

    /**
     * 发起搜索
     * @param params
     * @constructor
     */
    makeSearch = (params) => {
        this.setState({
            searchKey: params
        })
        var that = this
        setTimeout(function () {
            that.tableDataSync()
        }, 200)
    }
    /**
     * 签名列表
     * @param pageNumber
     Object.assign(para, that.state.keywords)
     * @param pageSize
     * @constructor
     */
    tableDataSync = (pageNumber = 1) => {
        let that = this;
        let para = {};
        para.pageNumber = pageNumber;
        para.pageSize = 20;
        that.setState({
            tableLoad: true
        })
        Object.assign(para, that.state.searchKey)
        apis.eiamEndpoints(para).then(function (resp) {
            that.setState({
                tableLoad: false
            })
            var curr = {
                total: resp.data.data.total,
                pageNumber: pageNumber
            }
            that.setState({
                tableData: resp.data.data.data,
                paging: curr
            })
        })
    }


    render() {
        var that = this

        const columns = [
            {
                title: "ID",
                dataIndex: "id"
            },
            {
                title: "所属产品",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <div>{row.group.product.name}</div>
                    )
                }
            },
            {
                title: "所属分组",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <div>{row.group.name}</div>
                    )
                }
            },
            {
                title: "节点名称",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <div style={{fontSize: "14px", fontWeight: "400"}}>{row.name}</div>
                    )
                }
            },
            {
                title: "资源地址",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <span style={{color:"#bf0257"}}>{row.slug}</span>
                    )
                }
            },
            {
                title: "资源类型",
                key: "id",
                render: function (value, row, index) {
                    return row.terminal_code
                }
            },
            {
                title: "可用",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <UI.Button shape={"round"} type={"circle"} style={{backgroundColor: row.state ? "green" : "red",color: "white"}}>{row.state ? '是' : '否'}</UI.Button>
                    )
                }
            },
            {
                title: "管理",
                key: "id",
                fixed: "right",
                render: function (value, row, index) {
                    return (
                        <span>
                             <UI.Button onClick={() => {
                                 var data = JSON.parse(JSON.stringify(row))
                                 data.group = data.group.id
                                 that.setState({
                                     editCurr: data,
                                     editShow: true
                                 })
                             }} type={"link"}>编辑</UI.Button>
                        </span>
                    )
                }
            }
        ]

        return (
            <div>
                <PageHeader title="授权节点" subTitle="授权节点管理" extra={[
                    <UI.Button key="1" type="primary" shape="round" onClick={() => {
                        that.setState({
                            editCurr: {
                                filter_value: 'view',
                                terminal_code: 'pc_view'
                            },
                            editShow: true,
                            submitting: false
                        })
                    }}>新增节点</UI.Button>
                ]}/>
                <UI.Card>
                    <div style={{marginTop: '22px'}}>
                        <UI.Form onFinish={that.makeSearch} layout={"inline"}>
                            <UI.Form.Item label={"节点名称"} name={"name__contains"}>
                                <UI.Input placeholder={"节点名称"}/>
                            </UI.Form.Item>
                            <UI.Form.Item label={"分组名称"} name={"group__name__contains"}>
                                <UI.Input placeholder={"分组名称"}/>
                            </UI.Form.Item>
                            <UI.Form.Item label={"产品名称"} name={"group__product__name__contains"}>
                                <UI.Input placeholder={"产品名称"}/>
                            </UI.Form.Item>
                            <UI.Form.Item>
                                <UI.Button type={"primary"} htmlType={"submit"}>快速搜索</UI.Button>
                            </UI.Form.Item>
                        </UI.Form>
                    </div>
                </UI.Card>

                <div style={{marginTop: '22px'}}>
                    <UI.Table
                        rowKey="id"
                        dataSource={this.state.tableData}
                        columns={columns}
                        loading={this.state.tableLoad}
                        pagination={{
                            total: this.state.paging.total,
                            defaultPageSize: 20,
                            defaultCurrent: this.state.paging.pageNumber,
                            onChange: this.tableDataSync
                        }}/>
                </div>

                <UI.Modal visible={that.state.editShow} title={'权限节点管理'} onCancel={() => {
                    that.setState({
                        editCurr: {},
                        editShow: false,
                        submitting: false
                    })
                }} footer={null} destroyOnClose>
                    <UI.Form onFinish={(params => {
                        that.setState({
                            submitting: true
                        })
                        if (that.state.editCurr.id) {
                            params.id = that.state.editCurr.id
                        }
                        apis.eiamEndpointAdmin(params).then(resp => {
                            that.setState({
                                submitting: false
                            })
                            if (resp.data.code === 200 && resp.data.data.code === 200) {
                                UI.message.success("提交信息成功")
                                that.tableDataSync(that.state.editCurr.id ? that.state.paging.pageNumber : 1)
                                that.setState({
                                    submitting: false,
                                    editShow: false,
                                    editCurr: {}
                                })
                            } else {
                                UI.message.error(resp.data.data.msg ? resp.data.data.msg : resp.data.msg)
                            }
                        })
                    })} labelCol={{span: 24}} labelAlign={"left"} initialValues={that.state.editCurr}>
                        <UI.Form.Item label={"节点名称"} name={"name"}
                                      rules={[{required: true, message: '节点名称'}]}>
                            <UI.Input placeholder={"节点名称"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"排序"} name={"sort"}
                                      rules={[{required: true, message: '排序'}]}>
                            <UI.InputNumber min={1} style={{width: "100%"}} placeholder={"排序"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"节点代码"} name={"code"}
                                      rules={[{required: true, message: '节点代码'}]}>
                            <UI.Input placeholder={"节点代码"} disable={that.state.editCurr.id}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"过滤参数"} name={"filter_value"}
                                      rules={[{required: true, message: '过滤参数'}]}>
                            <UI.Input placeholder={"过滤参数"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"终端代码"} name={"terminal_code"}
                                      rules={[{required: true, message: '终端代码'}]}>
                            <UI.Input placeholder={"终端代码"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"授权组"} name={"group_id"} rules={[{required: true, message: '授权组'}]}>
                            <UI.Select placeholder={"授权组"} style={{width: "100%"}}>
                                {that.state.group.map(item => {
                                    return (
                                        <Option value={item.id} key={item.id}>{item.name}</Option>
                                    )
                                })}
                            </UI.Select>
                        </UI.Form.Item>
                        <UI.Form.Item label={"节点状态"} name={"state"}
                                      rules={[{required: true, message: '节点状态'}]}>
                            <UI.Radio.Group>
                                <UI.Radio value={true}>可用</UI.Radio>
                                <UI.Radio value={false}>禁用</UI.Radio>
                            </UI.Radio.Group>
                        </UI.Form.Item>
                        <UI.Form.Item label={"SLUG地址"} name={"slug"}
                                      rules={[{required: true, message: 'SLUG地址'}]}>
                            <UI.Input placeholder={"SLUG地址"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"中间件"} name={"middlewares"}
                                      rules={[{required: false, message: '中间件'}]}>
                            <UI.Input placeholder={"中间件"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"图标"} name={"icon"}
                                      rules={[{required: false, message: '图标'}]}>
                            <UI.Input placeholder={"图标"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"节点介绍"} name={"remark"}
                                      rules={[{required: false, message: '节点介绍'}]}>
                            <TextArea rows={8} placeholder={"节点介绍"}/>
                        </UI.Form.Item>
                        <UI.Form.Item>
                            <UI.Button htmlType={"submit"} loading={that.state.submitting} type={"primary"}
                                       block>立即提交
                            </UI.Button>
                        </UI.Form.Item>
                    </UI.Form>
                </UI.Modal>
            </div>
        )
    }
}